<template>
  <section class="download-logo">
    <PageInset columns="1">
      <div class="download-logo__wrapper">
        <div class="download-logo__info">
          <h3>
            <TextHeading>Morrisons Logos</TextHeading>
          </h3>
          <p>logotype for Morrisons Groceries, Eat Fresh and Morrisons Occasions represents our core products.</p>
          <div class="download-logo__button">
            <BaseButton rounded="full" variant="primary">
              <BaseIcon name="get_app" size="28"></BaseIcon>
            </BaseButton>
            <span class="download-logo__button-text">Download</span>
          </div>
          <BaseIconText
            iconBefore="info"
            size="24"
            class="download-logo__guidelines"
          >Download requires following company and brand guidelines.</BaseIconText>
        </div>
        <div class="download-logo__logo">
          <MorrisonsLogo></MorrisonsLogo>
        </div>
      </div>
    </PageInset>
  </section>
</template>

<script>
import PageInset from '../elements/PageInset.vue'
import TextHeading from '../elements/TextHeading.vue'
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import BaseIconText from '../elements/BaseIconText.vue'
import MorrisonsLogo from '@/assets/svg/Wm_Morrison_Supermarkets_logo.svg?inline'
export default {
  name: 'DownloadLogo',
  components: {
    MorrisonsLogo,
    BaseIconText,
    BaseButton,
    BaseIcon,
    TextHeading,
    PageInset
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>

<style lang="postcss">
.download-logo {
  @apply bg-primary-lightest p-6;
}
.download-logo__wrapper {
  @apply flex flex-wrap;
}
.download-logo__info {
  @apply w-full mb-4;
}
.download-logo h3 {
  @apply mb-4;
}
.download-logo p {
  @apply text-lg mb-6;
}
.download-logo__button {
  @apply w-auto flex justify-start items-center font-semibold text-secondary text-lg mb-8;
}
.download-logo__button-text {
  @apply pl-4;
}
.download-logo__guidelines {
  @apply text-sm font-normal tracking-wide;
}
a.download-logo__guidelines {
  @apply no-underline text-body;
}
a.download-logo__guidelines:hover {
  @apply text-primary;
}
.download-logo__logo {
  @apply hidden flex-1 flex items-center justify-center;
}
.download-logo__logo svg {
  @apply h-auto w-5/6;
}
@screen md {
  .download-logo {
    @apply px-0 py-12;
  }
  .download-logo__wrapper {
    @apply flex-no-wrap;
  }
  .download-logo__info {
    @apply w-auto flex-1 mb-0;
  }
  .download-logo__logo {
    @apply flex;
  }
  .download-logo__button {
    @apply mb-12;
  }
}
@screen lg {
  .download-logo__logo svg {
    @apply h-auto w-3/5 px-3 ml-4;
  }
}
</style>
